/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Submittitle1Inputs */

const id_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim Ulasan`)
};

const ms_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar Ulasan`)
};

const da_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsend en Anmeldelse`)
};

const de_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung einreichen`)
};

const en_us2_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a Review`)
};

const es_es2_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar una reseña`)
};

const es_mx2_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar una reseña`)
};

const fil_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magsumite ng Review`)
};

const fr_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre un avis`)
};

const it_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia una recensione`)
};

const hu_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értékelés beküldése`)
};

const nl_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review indienen`)
};

const no_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send inn en omtale`)
};

const pl_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj recenzję`)
};

const pt_br2_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a Review`)
};

const pt_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar uma avaliação`)
};

const ro_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trimite o recenzie`)
};

const fi_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä arvostelu`)
};

const sv_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka en recension`)
};

const vi_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi đánh giá`)
};

const tr_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorum Gönder`)
};

const cs_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat recenzi`)
};

const bg_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изпращане на ревю`)
};

const ru_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить обзор`)
};

const uk_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надіслати відгук`)
};

const ar_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال مراجعة`)
};

const hi_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा सबमिट करें`)
};

const th_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งรีวิว`)
};

const ja_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビューを投稿`)
};

const zh_cn2_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a Review`)
};

const zh_hant1_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a Review`)
};

const ko_forms_review_submittitle1 = /** @type {(inputs: Forms_Review_Submittitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a Review`)
};

/**
* | output |
* | --- |
* | "Submit a Review" |
*
* @param {Forms_Review_Submittitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_submittitle1 = /** @type {((inputs?: Forms_Review_Submittitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Submittitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_submittitle1(inputs)
	if (locale === "ms") return ms_forms_review_submittitle1(inputs)
	if (locale === "da") return da_forms_review_submittitle1(inputs)
	if (locale === "de") return de_forms_review_submittitle1(inputs)
	if (locale === "en-US") return en_us2_forms_review_submittitle1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_submittitle1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_submittitle1(inputs)
	if (locale === "fil") return fil_forms_review_submittitle1(inputs)
	if (locale === "fr") return fr_forms_review_submittitle1(inputs)
	if (locale === "it") return it_forms_review_submittitle1(inputs)
	if (locale === "hu") return hu_forms_review_submittitle1(inputs)
	if (locale === "nl") return nl_forms_review_submittitle1(inputs)
	if (locale === "no") return no_forms_review_submittitle1(inputs)
	if (locale === "pl") return pl_forms_review_submittitle1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_submittitle1(inputs)
	if (locale === "pt") return pt_forms_review_submittitle1(inputs)
	if (locale === "ro") return ro_forms_review_submittitle1(inputs)
	if (locale === "fi") return fi_forms_review_submittitle1(inputs)
	if (locale === "sv") return sv_forms_review_submittitle1(inputs)
	if (locale === "vi") return vi_forms_review_submittitle1(inputs)
	if (locale === "tr") return tr_forms_review_submittitle1(inputs)
	if (locale === "cs") return cs_forms_review_submittitle1(inputs)
	if (locale === "bg") return bg_forms_review_submittitle1(inputs)
	if (locale === "ru") return ru_forms_review_submittitle1(inputs)
	if (locale === "uk") return uk_forms_review_submittitle1(inputs)
	if (locale === "ar") return ar_forms_review_submittitle1(inputs)
	if (locale === "hi") return hi_forms_review_submittitle1(inputs)
	if (locale === "th") return th_forms_review_submittitle1(inputs)
	if (locale === "ja") return ja_forms_review_submittitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_submittitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_submittitle1(inputs)
	return ko_forms_review_submittitle1(inputs)
});
export { forms_review_submittitle1 as "forms.review.submitTitle" }